import React, {useContext, useState} from "react";
import {Col, Container, Form, Row} from "react-bootstrap";

import useWindowDimensions from "hooks/Dimensions";
import {ActionPanelContext} from "../../context/action";

export default function SwiftTransactionRejectModal(props) {
    const {
        selectedRows,
        onCancel,
        setShow,
        setShowSwiftTxReject
    } = props;
    const {isMobile} = useWindowDimensions();
    const [submitting, setSubmitting] = useState(false);
    const {handleSwiftTransactionReject} = useContext(ActionPanelContext);

    const handleRejectClick = () => {
        if (submitting) return;
        setSubmitting(true);

        const onSuccess = () => {
            setSubmitting(false);
            setShow(false);
            setShowSwiftTxReject(false);
        };

        const onError = () => {
            setSubmitting(false);
            setShow(false);
            setShowSwiftTxReject(false);
        };

        handleSwiftTransactionReject(selectedRows, onSuccess, onError);
    };

    const handleKeyPress = (e) => {
        if (e.key === "Enter") {
            handleRejectClick();
            e.preventDefault();
        }
    };

    return (
        <Container className="my-3 my-md-0">
            <Form onSubmit={(e) => e.preventDefault()} onKeyPress={handleKeyPress}>
                <Row>
                    <Col md={12} className='pb-2'>
                        <h5 className="mb-2">Reject Transaction</h5>
                        <div className="mb-3">Are you sure you want to reject the transaction?</div>
                    </Col>
                </Row>
                <Row className={"justify-content-end"}>
                    <Col md={4} xs={12} className='pr-0 d-none d-md-block'>
                        <button className='btn btn-block td-btn-secondary-clear' href="#" disabled={submitting}
                                onClick={onCancel}>Cancel
                        </button>
                    </Col>
                    <Col md={4} xs={11} sm={12} className={isMobile ? 'stick-to-bottom' : ''}>
                        <button className={'btn btn-block td-btn-red'} href="#" disabled={submitting}
                                onClick={handleRejectClick}>Reject
                        </button>
                    </Col>
                </Row>
            </Form>
        </Container>
    );
}
